export default __webpack_public_path__ + "static/media/vendor_payment_advice.5950c4f8.xlsx";